export const EN = {
    "Open document": "Open document",
    "Upload file": "Upload file",
    "Drop file here to upload": "Drop file here to upload",
    "Disc": "Disc",
    "URL": "URL",
    "FILE": "FILE",
    "SIZE": "SIZE",
    "MB": "MB",
    "KB": "KB",
    "Bytes": "Bytes",
    "Loading... Please wait.": "Loading... Please wait.",
    "Fit Width": "Fit Width",
    "Fit Height": "Fit Height",
    "Password protected document": "Password protected document",
    "Password": "Password",
    "Open": "Open",
    "Password Required": "Password Required",
    "Incorrect password": "Incorrect password",
    "Error": "Error",
    "Something went wrong": "Something went wrong",
    "Server is not available": "Server is not available",
    "of": "of",
    "Please wait...": "Please wait..."
};